export default __webpack_public_path__ + "static/media/exportIcon.28f153fa.svg";